export const SN_EQUIPMENT_GUIDE = 'equipment_guide'
export const EQUIPMENT_GUIDE_SET_EQUIPMENT_GUIDE = SN_EQUIPMENT_GUIDE + '/SET_EQUIPMENT_GUIDE'
